import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { rootReducers } from 'redux/reducers';
import { rootSagas } from 'redux/sagas';

// Create Middleware
const sagaMiddleware = createSagaMiddleware();
const appMiddlewares = applyMiddleware(sagaMiddleware);

// Create rootMiddleware based on environment
let rootMiddleware;
if (process.env.NODE_ENV !== 'production') {
  // non-prod env
  const { composeWithDevTools } = require('redux-devtools-extension');
  rootMiddleware = composeWithDevTools(appMiddlewares);
} else {
  // prod env
  rootMiddleware = appMiddlewares;
}

// Create store
const store = createStore(rootReducers, rootMiddleware);

// Run saga
sagaMiddleware.run(rootSagas);

export default store;
